import {
  ShieldCheck,
  Wrench,
  Cpu,
  ClipboardCheck,
  Droplets,
  Disc3,
  Award,
  Target,
  Gauge,
  Handshake,
} from "lucide-react";

export const CONTACT = {
  phone: "0823 278100",
  phoneHref: "tel:+390823278100",
  whatsapp: "https://wa.me/393273065945",
  email: "pasqualenatale71@libero.it",
  emailHref: "mailto:pasqualenatale71@libero.it",
  address: "Via Roma 133, 81100 Caserta CE",
  hours: [
    { day: "Lunedì – Venerdì", time: "7:30 – 18:30" },
    { day: "Sabato", time: "7:30 – 13:00" },
    { day: "Domenica", time: "Chiuso" },
  ],
  mapEmbed:
    "https://www.google.com/maps?q=41.06983,14.3398&z=16&output=embed",
};

export const NAV_LINKS = [
  { label: "Home", target: "hero" },
  { label: "Chi siamo", target: "chi-siamo" },
  { label: "Servizi", target: "servizi" },
  { label: "Galleria", target: "galleria" },
  { label: "Contatti", target: "contatti" },
];

export const STATS = [
  { display: "Dal 1972", label: "Al tuo servizio" },
  { value: 12000, suffix: "+", label: "Veicoli assistiti" },
  { value: 100, suffix: "%", label: "Servizio affidabile" },
];

export const SERVICES = [
  {
    id: "revisione",
    icon: ShieldCheck,
    title: "Revisione Auto",
    desc: "Centro revisioni autorizzato per controlli completi sulla sicurezza e conformità del veicolo.",
  },
  {
    id: "meccanica",
    icon: Wrench,
    title: "Meccanica Generale",
    desc: "Riparazioni e manutenzione ordinaria e straordinaria per ogni tipo di automobile.",
  },
  {
    id: "diagnosi",
    icon: Cpu,
    title: "Diagnosi Elettronica",
    desc: "Analisi professionale dei sistemi elettronici del veicolo tramite strumenti avanzati.",
  },
  {
    id: "tagliandi",
    icon: ClipboardCheck,
    title: "Tagliandi Auto",
    desc: "Analisi professionale con l'ausilio di sistemi elettronici di ultima generazione.",
  },
  {
    id: "olio",
    icon: Droplets,
    title: "Cambio Olio e Filtri",
    desc: "Servizio rapido e professionale per la cura del motore.",
  },
  {
    id: "freni",
    icon: Disc3,
    title: "Impianto Frenante",
    desc: "Controllo e sostituzione componenti per garantire massima sicurezza.",
  },
];

export const REASONS = [
  {
    icon: Award,
    title: "Esperienza pluriennale",
    desc: "Decenni di esperienza nel settore automobilistico.",
  },
  {
    icon: Target,
    title: "Professionalità",
    desc: "Ogni intervento viene eseguito con precisione e attenzione.",
  },
  {
    icon: Gauge,
    title: "Tecnologia moderna",
    desc: "Utilizziamo strumenti diagnostici aggiornati.",
  },
  {
    icon: Handshake,
    title: "Trasparenza",
    desc: "Preventivi chiari e rapporto diretto con il cliente.",
  },
];

export const GALLERY = [
  {
    url: "https://customer-assets-eiarnc6j.emergentagent.net/job_natale-mechanics/artifacts/hmsi9l5m_foto%201.jpeg",
    caption: "Autofficina Ciro Natale",
  },
  {
    url: "https://customer-assets-eiarnc6j.emergentagent.net/job_natale-mechanics/artifacts/l2crvsc4_Foto%202.jpeg",
    caption: "Autofficina Ciro Natale",
  },
  {
    url: "https://customer-assets-eiarnc6j.emergentagent.net/job_natale-mechanics/artifacts/msy0k2kr_foto%203.jpeg",
    caption: "Autofficina Ciro Natale",
  },
  {
    url: "https://customer-assets-eiarnc6j.emergentagent.net/job_natale-mechanics/artifacts/pwrkofec_foto%204.jpeg",
    caption: "Autofficina Ciro Natale",
  },
  {
    url: "https://customer-assets-eiarnc6j.emergentagent.net/job_natale-mechanics/artifacts/ly1fztag_foto%205.jpeg",
    caption: "Autofficina Ciro Natale",
  },
];

export const REVIEWS = [
  {
    name: "Marco R.",
    text: "Professionalità e competenza. Ho trovato un servizio preciso e affidabile.",
  },
  {
    name: "Giulia D.",
    text: "Un'officina dove esperienza e tecnologia lavorano insieme. Consigliatissima.",
  },
  {
    name: "Antonio P.",
    text: "Revisione veloce e preventivo chiaro. Personale gentile e disponibile.",
  },
];

export const HERO_IMG =
  "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBhdXRvJTIwcmVwYWlyJTIwc2hvcCUyMG1lY2hhbmljJTIwZGFya3xlbnwwfHx8fDE3ODQzODIxMDd8MA&ixlib=rb-4.1.0&q=85";

export const ABOUT_IMG =
  "https://images.pexels.com/photos/4116221/pexels-photo-4116221.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940";
